const cn = {
	login: '登录',
	logout: '登出',
	signin: '登入',
	signup: '注册',
	email: '电子邮件',
	emailAddr: '电子邮件地址',
	password: '密码',
	rememberMe: '记住账号',
	forgotYourPwd: '忘记密码了吗？',
	signinFacebook: '使用Facebook登录',
	signinGoogle: '使用Google登录',
	dontAccount: '还没有帐号？',
	firstName: '名字',
	lastName: '姓',
	confirmPwd: '确认密码',
	signup_msg: '点击立即加入，即表示您同意',
	digitX_user_agreement: 'DigitXchange用户协议',
	privacy_policy: '隐私政策',
	and: '和',
	cookies_policy: 'Cookies政策',
	have_account: '已经有一个帐号',
	forgotPwd: '忘记密码',
	recoverPwd: '恢复密码',
	forgotPwd_msg: '将您的电子邮件放在上面的字段中，我们将向您发送一个包含以下说明的链接。',
	changePwd: '更改密码',
	oldPwd: '旧密码',
	newPwd: '新密码',
	confirmNewPwd: '确认新密码',
	user_account: '用户帐号',
	change_pic: '更换图片',
	mobile_number: '手机号码',
	country: '国家',
	update_settings: '更新设定',
	company: '公司',
	aboutUs: '关于我们',
	tos: '服务条款',
	copyright: '版权',
	socialMedia: '社交媒体',
	forUpdates: '更新',
	footer_msg_1: '通过注册即表示您接受',
	terms: '服务条款',
	contactUs: '联系我们',
	yourEmail: '你的邮件',
	required: '需要',
	yourMsg: '你的信息',
	sent: '已发送',
	footer_msg_2: '保留所有权利',
	footer_msg_3: '所有产品名称，商标和注册商标均为其各自所有者的财产',
	doom: '毁灭战士III',
	filter: '过滤',
	add_asset: '添加资产',
	request_game: '要求游戏',
	search_msg: '抱歉，没有符合您的搜索条件。',
	post: '发布',
	asset: '资产',
	create: '创建',
	character: '字符',
	characters: '性格',
	assets: '资产',
	profile: '轮廓',
	game: '游戏',
	games: '游戏类',
	currency: '货币',
	store: '商店',
	all_time: '整天',
	this_month: '这个月',
	trending: '趋向',
	item_name: '项目名',
	view_item: '查看项目',
	leaderboard: '排行榜',
	posters: '招贴画',
	chinese: '中文',
	english: '英语',
	japanese: '日本',
	korean: '韩语',
	german: '德语',
	french: '法文',
	spanish: '西班牙文',
	italian: '义大利文',
	russian: '俄语',
	portuguese: '葡萄牙语',
	hindi: '印地语',
	arabic: '阿拉伯',
	buy: '购买',
	subscription: '订阅',
	buy_subscription: '购买订阅',
	gift: '礼品',
	xchange: 'Xchange',
	subscription_plan: '认购计划',
	payment_options: '付款方式',
	cardholder_name: '持卡人姓名',
	submit_order: '提交订单',
	card_number: '卡号',
	cvv: 'CVV',
	expiration_date: '截止日期',
	buyXchange: '购买Xchange',
	giftXchange: '礼物Xchange',
	or: '要么',
	select: '选择',

	search: '搜索',
	search_games: '搜索游戏...',
	search_assets: '搜索资产...',
	platform: '平台',
	total_posts: '总帖子',
	total_comments: '总评论数',
	total_characters: '总字符数',
	total_assets: '总资产',
	xchange_currency: 'Xchange货币',
	subscription_days_remaining: '剩余订阅天数',
	total_asset_networth: '总资产净值',
	total_character_networth: '总人物Networth',
	most_downloaded: '下载最多',
	recently_added: '最近添加的',
	genre: '类型',
	my_library: '我的图书馆',
	most_commented: '评论最多',
	most_recent: '最近的',
	nearing_addition: '临近加法',
	create_asset: '创建资产',
	create_character: '创建角色',
	asset_name: '资产名称',
	asset_type: '资产类型',
	rarity: '稀有度',
	enhancements: '增强功能',
	add: '加',
	currency_type: '货币种类',
	price: '价钱',
	description: '描述',
	upload_asset: '上载资产',
	preview_asset: '预览资产',
	main_image: '主图',
	upload_video: '上载影片',
	upload: '上载',
	view_demo: '观看演示',
	character_name: '角色名字',
	character_type: '角色类型',
	upload_character: '上载角色',
	preview_character: '预览角色',
	race: '种族',
	class: '类',
	gender: '性别',
	level: '水平',
	showing: '显示中',
	of: '的',
	results: '结果',
	featured_characters: '特色人物',
	url: '网址',
	submit: '提交',
	real_world: '真实世界',
	game_currency: '游戏币',
	all: '所有',

	edit: '编辑',
	save: '保存',
	agg_character_networth: '汇总字符Networth',
	agg_time_played: '累计播放时间',
	agg_asset_value: '资产总值',
	enter_character_creation_date: '输入角色创建日期',
	in_game_currency: '游戏货币',
	real_world_value: '现实世界的价值',
	update_character: '更新角色',
	item_not_found: '找不到商品！',
	ripper: '开膛手',
	comments: '注释',
	add_comments: '添加评论',
	new_suggested_price: '新建议价',
	sort_by: '排序方式',
	reply: '回复',
	asset_networth: '资产净值',
	join_date: '参加日期',
	report: '报告',
	first: '第一',
	last: '持续',
	most_replies: '最多回覆',
	new_pricing_recommendations: '新定价建议',
	xchange_amount: '兑换金额',
	username: '用户名',
	send_gift: '送礼物',
	message: '信息',
	gift_text: '在此处个性化您的信息',
	day: '天',
	days: '天',
	currency_converter: '货币换算',
	from: '从',
	to: '至',
	in_game: '在游戏中',
	real_life: '现实生活',
	cvc: 'CVC',
	card: '卡',
	per_month: '每月（每月3美元）',
	per_year: '每年（每年30美元）',
	aboutUs_text: 'DigitXChange是一个社区驱动的网站，旨在最终通过众包来评估数字商品和服务的价值。如果您曾经问​​过“我的角色实际上值多少钱”或“我想知道与另一个游戏中的另一个玩家进行公平交易”的问题，请不要再寻找答案了。我们希望您喜欢我们的网站，参与建立团队知识，炫耀来之不易的赃物，并最终期盼发现您的总数字净资产！',
	home: '主页',
	all_time_characters: '所有时间角色',
	this_month_characters: '本月人物',
	trending_characters: '热门人物',
	all_time_posters: '所有时间海报',
	this_month_posters: '本月海报',
	trending_posters: '热门海报',

};

export default cn;


// WEBPACK FOOTER //
// ./src/translations/cn.js